const DEV_SERVICE_WORKER_URL = '/service-worker.js';
const DEFAULT_SERVICE_WORKER_FILE = 'service-worker.js';
const DEFAULT_INDEX_FILE = 'index.html';

const joinPath = (...parts) =>
    `/${parts
        .map((part) => String(part || '').replace(/^\/+|\/+$/g, ''))
        .filter(Boolean)
        .join('/')}`;

const getPublicPathname = () => {
    const base = process.env.PUBLIC_URL || '/';

    if (/^https?:\/\//.test(base)) {
        try {
            return new URL(base).pathname || '/';
        } catch (e) {
            return '/';
        }
    }

    return base;
};

export const getMarketCodeFromPathname = (pathname = '') => {
    try {
        const MARKET_CODE_INDEX = 1;
        const marketCode = pathname.split('/')[MARKET_CODE_INDEX];

        if (!marketCode || marketCode.includes('.')) {
            return null;
        }

        return marketCode;
    } catch (e) {
        return null;
    }
};

export const getServiceWorkerUrl = (pathname = '') => {
    const marketCode = getMarketCodeFromPathname(pathname);

    if (process.env.REACT_APP_ENV === 'dev') {
        return DEV_SERVICE_WORKER_URL;
    }

    if (marketCode) {
        return joinPath(marketCode, DEFAULT_SERVICE_WORKER_FILE);
    }

    return joinPath(getPublicPathname(), DEFAULT_SERVICE_WORKER_FILE);
};

export const getServiceWorkerIndexUrl = () => {
    return joinPath(getPublicPathname(), DEFAULT_INDEX_FILE);
};
